class FeatureCard extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("mouseover", () => {
      const content = this.querySelector(".card__content-text");
      const width = getComputedStyle(content).width;

      // Set properties to calculate height whilst hiding element
      content.style.width = width;
      content.style.position = "absolute";
      content.style.visibility = "hidden";
      content.style.height = "auto";

      const height = getComputedStyle(content).height;

      // Reset properties used above to calculate height
      content.style.width = null;
      content.style.position = null;
      content.style.visibility = null;
      content.style.height = "0";

      getComputedStyle(content).height;
      requestAnimationFrame(() => (content.style.height = height));
    });

    this.addEventListener("mouseleave", () => {
      const content = this.querySelector(".card__content-text");
      content.style.height = "0";
    });
  }
}

customElements.define("feature-card", FeatureCard);
